import { Tab, Tabs } from "@leap4/frontend";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { urlService } from "../../routing/urlsService";

/** Real routes rather than local state, so an investigation is linkable. */

export type DashboardTabKey = "overall" | "publishers" | "explorer";

const TABS: { key: DashboardTabKey; label: string; path: string }[] = [
    { key: "overall", label: "Overall", path: urlService.dashboard() },
    { key: "publishers", label: "Publishers", path: urlService.dashboardPublishers() },
    { key: "explorer", label: "Explorer", path: urlService.dashboardExplorer() },
];

const DashboardTabs = ({ active }: { active: DashboardTabKey }): JSX.Element => {
    const history = useHistory();
    const location = useLocation();
    // Carry the campaign across tabs; switching tab is not a reason to change what you are looking at.
    const campaign = new URLSearchParams(location.search).get("campaign");
    return (
        <Tabs
            value={active}
            onChange={(_e: unknown, next: DashboardTabKey) => {
                const tab = TABS.find((t) => t.key === next);
                if (tab) history.push(campaign ? `${tab.path}?campaign=${campaign}` : tab.path);
            }}
            sx={{ minHeight: 36, "& .MuiTab-root": { minHeight: 36, py: 0 } }}
        >
            {TABS.map((t) => (
                <Tab key={t.key} value={t.key} label={t.label} />
            ))}
        </Tabs>
    );
};

export default DashboardTabs;
